import i18next from 'i18next'
import Config from 'config'

export default props => {
  const { name, value, prefix, dimensions } = props
  const { desktopUI, portrait } = dimensions

  const text = i18next.t(`${prefix}.${name}`)
  const textSizeClass = text.length >= 16 ? 'bigText' : ''
  const sizeClass = !desktopUI && !portrait && textSizeClass ? 'bigValue' : ''

  const quickspinEnabled = Config.FEATURE_CONFIG.QUICKSPIN

  return (
    <div className={`${name} info ${quickspinEnabled ? '' : 'no-quickspin'}`}>
      <div className="bg-field" />
      <div className={`infoArea ${sizeClass}`}>
        <span className="text">{value}</span>
      </div>
      <div className={`labels ${textSizeClass}`}>
        <div className="label">{text}</div>
      </div>
    </div>
  )
}
